/* eslint-env jest */
import {
  freeMagnetsBadge, freeMagnetsRow, isMagnetsOption, magnetsOptionLabel, FREE_MAGNETS_BADGE,
  freeItemBadge, freeItemRow, freeItemThumbnail,
} from './packageCardOffer';

const magnets = { couponType: 'FREE_MAGNETS_WITH_FREE_SHIPPING', value: 0, expiresOn: '2026-10-24' };
const pct = { couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', value: 20, expiresOn: '2026-10-24' };

describe('package card — free magnets tier (issue #5218)', () => {
  it('shows the badge only while the magnet tier is live', () => {
    expect(freeMagnetsBadge(magnets)).toBe(FREE_MAGNETS_BADGE);
    expect(freeMagnetsBadge(pct)).toBeNull();
    expect(freeMagnetsBadge(null)).toBeNull();
  });

  it('appends the checklist row with the deadline', () => {
    expect(freeMagnetsRow(magnets)).toBe('(2) FREE Photo Magnets — offer ends Saturday, October 24');
    expect(freeMagnetsRow({ ...magnets, expiresOn: null })).toBe('(2) FREE Photo Magnets');
    expect(freeMagnetsRow(pct)).toBeNull();
    expect(freeMagnetsRow(undefined)).toBeNull();
  });

  it('labels the a-la-carte Magnets option FREE with any package only while live', () => {
    expect(isMagnetsOption({ name: 'Magnets' })).toBe(true);
    expect(isMagnetsOption({ name: 'Photo Magnets' })).toBe(true);
    expect(isMagnetsOption({ name: 'Star Student' })).toBe(false);
    expect(magnetsOptionLabel({ name: 'Magnets' }, magnets)).toBe('FREE with any package');
    expect(magnetsOptionLabel({ name: 'Magnets' }, pct)).toBeNull();
    expect(magnetsOptionLabel({ name: 'Star Student' }, magnets)).toBeNull();
    expect(magnetsOptionLabel(null, magnets)).toBeNull();
  });
});

describe('package card — free item of your choice (#5747)', () => {
  const freeItem = {
    couponType: 'FREE_ADDON_CHOICE',
    value: 0,
    expiresOn: '2026-10-25',
    freeAddons: [
      { id: 160, name: 'Weekly Dry Erase Magnet - School', giftCategory: 'magnets', imageUrl: '/missing.png', priceWith: 29.95 },
      { id: 161, name: 'Weekly Dry Erase Magnet - Groovy', giftCategory: 'magnets', imageUrl: 'https://cdn/groovy.png', priceWith: 29.95 },
    ],
  };

  it('shows the badge, named from the category, only while the offer is live', () => {
    expect(freeItemBadge(freeItem)).toBe('+ FREE MAGNET');
    expect(freeItemBadge(pct)).toBeNull();
    expect(freeItemBadge({ ...freeItem, freeAddons: [] })).toBeNull();
  });

  it('appends the row: the item with package, no design count, no deadline', () => {
    expect(freeItemRow(freeItem)).toBe('Includes a FREE Weekly Dry Erase Magnet with package');
    expect(freeItemRow({ ...freeItem, freeItemLabel: 'dry erase magnet' })).toBe('Includes a FREE dry erase magnet with package');
    expect(freeItemRow(magnets)).toBeNull();
  });

  it('picks the first add-on WITH product art for the thumbnail, or none', () => {
    expect(freeItemThumbnail(freeItem)).toEqual({ src: 'https://cdn/groovy.png', alt: 'Weekly Dry Erase Magnet - Groovy', value: 29.95 });
    expect(freeItemThumbnail({ ...freeItem, freeAddons: [{ ...freeItem.freeAddons[1], priceWith: null }] }).value).toBeNull();
    expect(freeItemThumbnail({ ...freeItem, freeAddons: [freeItem.freeAddons[0]] })).toBeNull();
    expect(freeItemThumbnail(pct)).toBeNull();
  });
});
